module.exports = __webpack_public_path__ + "media/images/img/tag_company/gmo_tag-0086bf21451ed1967033980a3301ed37.png";